import React, { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

export const Lightbox = ({ images, index, onClose, onIndex }) => {
  const [loaded, setLoaded] = useState(false);
  const img = images[index];
  const prev = useCallback(() => onIndex((index - 1 + images.length) % images.length), [index, images.length, onIndex]);
  const next = useCallback(() => onIndex((index + 1) % images.length), [index, images.length, onIndex]);

  useEffect(() => {
    setLoaded(false);
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') prev();
      if (e.key === 'ArrowRight') next();
    };
    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => { window.removeEventListener('keydown', onKey); document.body.style.overflow = ''; };
  }, [index, onClose, prev, next]);

  useEffect(() => {
    [images[(index + 1) % images.length], images[(index - 1 + images.length) % images.length]].forEach((n) => { const p = new Image(); p.src = n.src; });
  }, [index, images]);

  if (!img) return null;
  return createPortal(
    <div className="fixed inset-0 z-[200] bg-[#120B07]/95 backdrop-blur-md flex items-center justify-center" data-testid="gallery-lightbox" role="dialog" aria-modal="true">
      <button type="button" onClick={onClose} aria-label="Close" data-testid="lightbox-close" className="absolute top-5 right-5 md:top-7 md:right-8 text-white/70 hover:text-white transition-colors p-2"><X size={26} /></button>
      <div className="absolute top-6 left-6 md:top-8 md:left-9 text-[10px] tracking-[0.35em] uppercase text-[#C9A56C]" data-testid="lightbox-counter">{String(index + 1).padStart(2, '0')} / {String(images.length).padStart(2, '0')}</div>

      <button type="button" onClick={prev} aria-label="Previous" data-testid="lightbox-prev" className="absolute left-2 md:left-6 top-1/2 -translate-y-1/2 text-white/60 hover:text-white transition-colors p-3"><ChevronLeft size={34} strokeWidth={1.25} /></button>
      <button type="button" onClick={next} aria-label="Next" data-testid="lightbox-next" className="absolute right-2 md:right-6 top-1/2 -translate-y-1/2 text-white/60 hover:text-white transition-colors p-3"><ChevronRight size={34} strokeWidth={1.25} /></button>

      <img
        key={img.src}
        src={img.src}
        alt={`AdAura Awards 2026 — awards night photograph ${index + 1}`}
        onLoad={() => setLoaded(true)}
        onClick={next}
        className={`max-h-[86vh] max-w-[92vw] md:max-w-[86vw] object-contain shadow-[0_30px_80px_-20px_rgba(0,0,0,0.8)] transition-opacity duration-500 ${loaded ? 'opacity-100' : 'opacity-0'}`}
        data-testid="lightbox-image"
      />
    </div>,
    document.body
  );
};

export default Lightbox;
